<template>
  <div class="infografias">
    <v-container data-aos="fade-up" class="header-container">
      <h2 class="notranslate pl-2 ">
        {{ $t("infografias.title") }}
      </h2>

      <!-- lista de redes sociales -->
      <v-spacer></v-spacer>
      <div class="ml-3 mt-2">
        <v-btn
          v-for="(social, index) in socials"
          :key="index"
          :href="social.url"
          target="_blank"
          icon
        >
          <v-icon class="social-media">{{ social.icon }}</v-icon>
        </v-btn>
      </div>
    </v-container>
    <v-container>
      <div data-aos="fade-up" data-aos-delay="50" class="body mb-9 px-3" v-html="$t('infografias.description')">
      </div>
      <v-row>
        <!-- show # of results -->

        <div data-aos="fade-up" data-aos-delay="100" class="grey-2 px-5">
          {{ infografias.length }} resultados
        </div>
      </v-row>
      <v-row>
        <v-col
          v-for="(infografia, index) in infografias"
          :key="infografia"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          class="d-flex justify-center"
        >
          <v-card
            data-aos="fade-up"
            data-aos-delay="150"
            class="mb-12 infografía__card"
            v-on:click="imageIndex = index"
          >
            <v-img class="infografia__image" :src="infografia" position="top center" aspect-ratio="1"> </v-img>
            <!-- <v-card-title >Infografia</v-card-title> -->
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <LightGallery
      :images="infografias"
      :index="imageIndex"
      :disable-scroll="true"
      @close="imageIndex = null"
    />
  </div>
</template>
<script>
import $ from "jquery";
import { LightGallery } from "vue-light-gallery";

export default {
  name: "Infografias",
  data: () => ({
    infografias: [],
    imageIndex: null
  }),
  components: { LightGallery },
  computed: {
    infografiasPath: () => $(location).attr("origin") + "/archivos/infografias/",
    socials: function() {
      return [
        {
          icon: "mdi-facebook",
          url: this.$info.about.information.facebook
        },
        {
          icon: "mdi-instagram",
          url: this.$info.about.information.instagram
        },
        {
          icon: "mdi-youtube",
          url: "https://www.youtube.com/@institutodeinvestigaciones9982"
        }
      ];
    }
  },
  mounted() {
    $.getJSON(this.infografiasPath, infografias => {
      if (!infografias) return;
      const infografias_list = [];
      infografias.forEach(image => {
        if (!image.includes(".jpeg") && !image.includes(".jpg") && !image.includes(".png")) return;
        infografias_list.push(this.infografiasPath + image);
      });
      this.infografias = [...infografias_list];
    });
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/global";
.infografias {
  width: 100%;
  height: 100%;

  padding: 0 10px;
  position: relative;
  margin-top: 150px;
}
.infografía__card {
  overflow: hidden;
  cursor: pointer !important;
  width: 273px !important;
}

.infografia__image {
  transition: all 0.3s ease-out;
}
.infografia__image:hover {
  transform: scale(1.1);
}
.header-container {
  position: relative;
  // display: flex;
}
.social-media {
  color: $green !important;
}

@media (max-width: 960px) {
  .infografias {
    margin-top: 75px;
  }
}
</style>
